import { Injectable } from '@angular/core';
import { SettingDbService } from '@shared/database/setting-db.service';
import { shareReplay } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SettingService {

  constructor(
    private settingDbService: SettingDbService,
  ) {
  }


  discountRates$ = this.settingDbService.get$('discountRates').pipe(shareReplay(1));

  public setDiscountRate(discountRate): Promise<any> {
    let data ={
      id: 'discountRates',
      ...discountRate
    }
    return this.settingDbService.upsert(data);
  }

}
